import {
    $,
    HttpBody,
    ID,
    Resource,
    ResponseSerialize,
    TAG,
    ValidationMaxLength,
    ValidationRequired,
} from 'simpli-web-sdk'
import CnpjBulkLogSchema from '@/schema/CnpjBulkLog.schema'
import TipoCnpjFuncao from '@/model/resource/TipoCnpjFuncao'

export default class CnpjBulkLog extends Resource {
    get $schema() {
        return CnpjBulkLogSchema(this)
    }

    get $id() {
        return this.idCnpjBulklogPk
    }

    set $id(val: ID) {
        this.idCnpjBulklogPk = val
    }

    get $tag() {
        return this.nome
    }

    set $tag(val: TAG) {
        this.nome = val
    }

    get tipoCnpjBulkLogResource() {
        return this.tipoCnpjFuncao
    }

    set tipoCnpjBulkLogResource(val: TipoCnpjFuncao) {
        this.tipoCnpjFuncao = val
    }

    static async persistLoteTipoOcorrencia(listToPersist: CnpjBulkLog[], spinner = 'persistLoteCnpjBulkLog') {
        const fetch = async () => {
            return await new HttpBody(Number).POST(`/user/lote-cnpj-bulklog`, listToPersist)
        }

        return await $.await.run(fetch, spinner)
    }

    readonly $name: string = 'CnpjBulkLog'

    readonly $endpoint: string = '/user/cnpj-bulklog{/id}'

    idCnpjBulklogPk: ID = 0

    @ResponseSerialize(TipoCnpjFuncao)
    tipoCnpjFuncao: TipoCnpjFuncao = new TipoCnpjFuncao()

    @ValidationRequired()
    @ValidationMaxLength(255)
    nome: string = ''

    @ValidationRequired()
    @ValidationMaxLength(255)
    cnpj: string = ''

    @ValidationRequired()
    ativo: boolean = false

    async persistCnpjBulkLog(spinner = 'persistCnpjBulkLog') {
        const fetch = async () => {
            await this.validate()
            return await this.POST(`/user/cnpj-bulklog`, this)
        }

        return await $.await.run(fetch, spinner)
    }

    async getCnpjBulkLog(id: ID, spinner = 'getCnpjBulkLog') {
        const fetch = async () => await this.GET(`/user/cnpj-bulklog/${id}`)
        return await $.await.run(fetch, spinner)
    }

    async removeCnpjBulkLog(id: number, spinner = 'removeCnpjBulkLog') {
        const fetch = async () => await this.DELETE(`/user/cnpj-bulklog/${id}`)
        return await $.await.run(fetch, spinner)
    }

}
